import endpointMapper from '../_endpoints'
import { addFavoriteApp, removeFavoriteApp } from '../_redux/actions/favoriteAppsActions'
import { APPLICATION_BEHAVIOUR } from '../_enums'
import { usePost } from '../_hooks/usePost'
import { useDispatch, useSelector } from 'react-redux'

export const useFavouriteApps = () => {
  const [, markFavourite] = usePost()
  const [, markUnfavourite] = usePost()
  const dispatch = useDispatch()
  const userProfile = JSON.parse(localStorage.getItem('userInfoData'))
  const userSid = useSelector((state) => state.userContextReducer.userContext.id)

  const addToFavourite = async (item) => {
    const result = await markFavourite({
      url: endpointMapper.userApplications.createUserApplication,
      data: {
        userSid,
        applicationId: item.id,
        eventType: APPLICATION_BEHAVIOUR.FAVOURITE_APPS
      }
    })

    if (result && result instanceof Object && Object.keys(result).length && result?.data) {
      dispatch(addFavoriteApp(item))
    }
  }

  const removeFromFavourite = async (item) => {
    const result = await markUnfavourite({
      url: endpointMapper.userApplications.deleteUserApplication,
      data: {
        userSid,
        applicationId: item.id,
        eventType: APPLICATION_BEHAVIOUR.FAVOURITE_APPS
      }
    })

    dispatch(removeFavoriteApp(item))
  }

  return { addToFavourite, removeFromFavourite }
}
